import { useState } from "react";
import { Button } from "@/components/ui/button";
import type { BuilderApi } from "../api.ts";
import { useNav } from "../nav.tsx";
import { ErrorNote, errText, SectionTitle } from "../ui.tsx";
import { AvatarPicker } from "./AvatarPicker.tsx";

export function NewEmployee({ api }: { api: BuilderApi }) {
  const { go } = useNav();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  return (
    <div>
      <Button variant="ghost" size="sm" className="mb-4" onClick={() => go("/")}>
        ← Employees
      </Button>
      <SectionTitle title="New employee" description="Every employee starts from an avatar published in the studio. Its look and voice are pinned to that exact release." />
      <ErrorNote error={error} />
      <AvatarPicker
        api={api}
        busy={busy}
        onPick={async (a) => {
          setBusy(true);
          setError(undefined);
          try {
            const e = await api.createEmployee({ avatarReleaseId: a.id });
            go(`/employees/${e.id}/identity`);
          } catch (err) {
            setError(errText(err));
            setBusy(false);
          }
        }}
      />
    </div>
  );
}
